/**
 * Canonical user-facing copy for the SPA.
 * Keep messages plain UK English — no infrastructure jargon on primary UI.
 */

export const genericCopy = {
  signInUnavailable: 'Sign-in is temporarily unavailable',
  signInOptions:
    'Could not reach the helpdesk service — check your connection and try again',
  retry: 'Retry',
  retrying: 'Retrying…',
  checkingService: 'Checking service…',
  loginFailed: 'Sign-in failed. Please try again.',
};
